import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { UpdateItemModelDto } from "@/core/features/item-models/update-item-model.dto";
import { CreateItemModelDto } from "@/core/features/item-models/create-item-model.dto";
import { ItemModelDto } from "@/core/features/item-models/item-model.dto";
import { IFilterModel } from "@/interfaces/IFilterModel";
import { OptionType } from "@/types/OptionType";
import { getOptionLoader } from "@/core/common/presenters/optionLoader";
import { IRequest } from "@/interfaces/IRequest";
import { HttpRequest } from "@/core/common/http/http-request";

export class ItemModelsResource extends ResourceBaseService<ItemModelDto, CreateItemModelDto, UpdateItemModelDto> {
  protected EntityDto = ItemModelDto;
  protected CreateEntityDto = CreateItemModelDto;
  protected UpdateEntityDto = UpdateItemModelDto;

  constructor(protected readonly apiHttClient: ApiHttpClient) {
    super(apiHttClient, "/item-models");
  }

  async optionLoader(inputValue: string, filters?: IFilterModel, customRequest?: IRequest): Promise<OptionType[]> {
    return getOptionLoader(
      inputValue,
      ["id", "name", "brand.name"],
      [{ field: "name", order: "ASC" }],
      (request) => this.findAll(customRequest ? Object.assign(request, customRequest) : request),
      ["name", "brand"],
      filters
    );
  }

  async importItemModels(file: File): Promise<{ status: string; jobId: string }> {
    const formData = new FormData();
    formData.append("file", file);

    return this.apiHttClient.request<FormData, { status: string; jobId: string }>(
      HttpRequest.create<FormData>({
        url: this.resourceUrl + "/import",
        method: "POST",
        auth: true,
        body: formData,
        type: "form-data",
      })
    );
  }

  async downloadImportTemplate(): Promise<void> {
    return this.downloadExcel(null, "/import/template", "plantilla-modelos-articulos");
  }
}
